import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useGetCompanyUpdatesQuery } from "../../../../store/Company/companyApiSlice";

/* What a followed company has changed since you last looked. */

/* Transcribed: this row is noise on every company, so it never surfaces. */
export const MEANINGFUL = (update) => update?.content !== "Company Profile Updated";

export const newerThan = (updates = [], viewedAt) =>
  updates.filter((u) => new Date(u?.timestamp) > new Date(viewedAt));

/* `viewedAt` overrides the follow's stored timestamp. */
export const useCompanyUpdates = (companyID, follow, viewedAt) => {
  const { token } = useSelector((state) => state.auth);
  const { data, isLoading, error } = useGetCompanyUpdatesQuery(
    { companyID, token },
    /* Same reason as the follow list: the args are identical on every visit,
       so without this the counts would be whatever was cached when the screen
       was last open. */
    { skip: !companyID, refetchOnMountOrArgChange: true }
  );

  return useMemo(() => {
    const updates = (data || []).filter(MEANINGFUL);
    /* Newest first, as the popup sorts them. */
    const sorted = [...updates].sort(
      (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
    );
    const latest = sorted.length > 0 ? sorted[0].timestamp : null;
    const seenAt = viewedAt || follow?.viewed_timestamp;
    const unseen = newerThan(sorted, seenAt);

    return {
      updates: sorted,
      total: sorted.length,
      latest,
      /* Transcribed guard: the badge shows only when the newest update is
         genuinely later than the last view AND something is unseen. */
      newCount: new Date(seenAt) < new Date(latest) ? unseen.length : 0,
      isLoading,
      error,
    };
  }, [data, follow?.viewed_timestamp, viewedAt, isLoading, error]);
};

export default useCompanyUpdates;
